module.exports = __webpack_public_path__ + "img/rghfgg.7c6313ec.jpeg";